import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Search } from 'lucide-react';
import { forwardRef } from 'react';
import { cn } from '../../lib/cn.js';
import { fieldClasses, fieldSizeClasses } from '../../lib/field-styles.js';
import { useTranslate } from '../../lib/i18n.js';
/**
 * Search field (handoff, Molecules). `type="search"` rather than `text`, so
 * the browser offers its own clear affordance and mobile keyboards show a
 * search key.
 *
 * Built on `fieldClasses` and the control scale rather than on its own
 * measurements. It used to hardcode `h-14`, which put it at 56px: taller than
 * `control-lg`, off the scale entirely, and the one field in the app that did
 * not move when the field height changed. The border and focus treatment were
 * copied inline too, so a change to the field's focus ring silently missed it.
 */
export const SearchField = forwardRef(function SearchField({ label, size = 'md', className, ...props }, ref) {
    const t = useTranslate();
    // The accessible name and the placeholder are the same words, and only one
    // of them is visible, so they come from one key.
    const name = label ?? t('ui.search.label');
    return (_jsxs("div", { className: cn('relative flex items-center', className), children: [_jsx(Search, { "aria-hidden": "true", className: "pointer-events-none absolute left-3.5 size-icon-sm text-text-muted" }), _jsx("input", { ref: ref, type: "search", "aria-label": name, placeholder: props.placeholder ?? t('ui.search.placeholder'), className: cn(fieldClasses(false), fieldSizeClasses(size), 'pl-10'), ...props })] }));
});
//# sourceMappingURL=SearchField.js.map